import * as React from "react";
const SvgTriangleRightLine = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, fill: "none", viewBox: "0 0 24 24", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M16.906 10.041a2 2 0 0 1 .091 2.827c-.044.047-.044.047-.091.091l-5.538 5.192A2 2 0 0 1 8 16.691V6.309a2 2 0 0 1 3.368-1.459zm-1.368 1.46L10 6.307v10.384z", clipRule: "evenodd" }));
export default SvgTriangleRightLine;
